/** @typedef {import('../models/photo-entity').default} PhotoEntity */

/* eslint-disable no-underscore-dangle */
class PhotosStorage {
  /**
   *Creates an instance of PhotosStorage.
   * @param {PhotoEntity} middlePhoto
   * @memberof PhotosStorage
   */
  constructor(middlePhoto) {
    this._photoList = [middlePhoto]
  }

  /**
   * Finds an index of a photo by its id
   *
   * @param {Number} photoId
   * @returns {?Number}
   * @memberof PhotosStorage
   */
  _findIndexByPhotoIdOrNull(photoId) {
    const index = this._photoList.findIndex((photo) => photo.id === photoId)
    return index === -1 ? null : index
  }

  /**
   * @param {PhotoEntity} photo
   * @memberof PhotosStorage
   */
  update(photo) {
    const index = this._findIndexByPhotoIdOrNull(photo.id)
    if (index !== null) {
      this._photoList.splice(index, 1, photo)
    }
  }

  /**
   * @param {number} photoPointId
   * @returns {PhotoEntity}
   * @memberof PhotosStorage
   */
  getPreviousOrNull(photoPointId) {
    const photoIndex = this._findIndexByPhotoIdOrNull(photoPointId)
    if (photoIndex === null) return null

    return this._photoList[photoIndex - 1] || null
  }

  /**
   * @param {number} photoPointId
   * @returns {PhotoEntity}
   * @memberof PhotosStorage
   */
  getNextOrNull(photoPointId) {
    const photoIndex = this._findIndexByPhotoIdOrNull(photoPointId)
    if (photoIndex === null) return null

    return this._photoList[photoIndex + 1] || null
  }

  /**
   * Inserts photos into the collection around the pointed photo
   * Photos with negative keys are inserted before the photo
   * Photos with positive keys are inserted after the photo
   *
   * @param {Object<number, PhotoEntity>} photos
   * @param {number} middlePhotoId
   * @memberof PhotosStorage
   */
  insert(photos, middlePhotoId) {
    const newPhotosBeforeMiddle = Object.entries(photos)
      .filter(([key]) => key < 0)
      .sort(([keyA], [keyB]) => keyB - keyA)
      .map(([, photo]) => photo)
    const newPhotosAfterMiddle = Object.entries(photos)
      .filter(([key]) => key > 0)
      .sort(([keyA], [keyB]) => keyA - keyB)
      .map(([, photo]) => photo)

    const middlePhotoIndex = this._findIndexByPhotoIdOrNull(middlePhotoId)
    const newPhotoList = this._photoList.slice(0, middlePhotoIndex)
    newPhotoList.push(...newPhotosBeforeMiddle)
    newPhotoList.push(this._photoList[middlePhotoIndex])
    newPhotoList.push(...newPhotosAfterMiddle)
    newPhotoList.push(...this._photoList.slice(middlePhotoIndex + 1))
    this._photoList = newPhotoList
  }
}

export default PhotosStorage
